import { Select } from "antd";
import React from "react";

function DropdownSelect({
  placeholder,
  options,
  labelKey,
  valueKey,
  onSelect,
  style = {},
  disabled = false,
  value = null,
}) {
  return (
    <div style={{ width: "100%" }}>
      <Select
        showSearch
        placeholder={placeholder}
        optionFilterProp="value"
        value={value || undefined}
        filterOption={(input, option) =>
          option?.value.toLowerCase().includes(input.toLowerCase())
        }
        style={{ minWidth: "100%", ...style }}
        onChange={onSelect}
        disabled={disabled}
        options={options.map((item) => {
          if (typeof item === "object" && item !== null) {
            return {
              label: item[labelKey],
              value: item[valueKey],
            };
          } else {
            return {
              label: item,
              value: item,
            };
          }
        })}
      />
    </div>
  );
}

export default DropdownSelect;
